module.exports = __webpack_public_path__ + "static/img/98028D_2_3_R_20181128_fit.3d97b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98028D_2_3_R_20181128_fit.png
// module id = hc6x
// module chunks = 0